export const DataSharingSection = () => (
  <section>
    <h2>5. Data Sharing</h2>

    <p>
      Legal Compliance: In exceptional circumstances, and except as stipulated
      otherwise in our Data Processing Addendum and other commercial agreements
      with you, we may disclose or allow government and law enforcement
      officials access to your Personal Data, in response to a subpoena, search
      warrant or court order (or similar requirement), or in compliance with
      applicable laws and regulations. Such disclosure or access may occur if we
      believe in good faith that: (a) we are legally compelled to do so; (b)
      disclosure is appropriate in connection with efforts to investigate,
      prevent, or take action regarding actual or suspected illegal activity,
      fraud, or other wrongdoing; or (c) such disclosure is required to protect
      our legitimate business interests, including the security or integrity of
      our products and services.
    </p>

    <p>
      Service Providers: We may engage selected third party companies and
      individuals to perform services complementary to our own. Such service
      providers include hosting and server co-location services, communications
      and content delivery networks (CDNs), data and cyber security services,
      billing and payment processing services, fintech services, fraud detection
      and prevention services, web analytics, e-mail distribution and monitoring
      services, session or activity recording services, remote access services,
      performance measurement, data optimization and marketing services, social
      and advertising networks, content providers, e-mail, voicemails, support
      and customer relation management systems, and our legal, financial and
      compliance advisors (collectively, "Service Providers").
    </p>

    <p>
      Our Service Providers shall each be deemed as a 'data processor' or
      'service provider' in circumstances where Volca assumes the role of 'data
      controller'; and where Volca acts as the 'data processor' or 'service
      provider' for our customer, the Service Provider shall be deemed as our
      'sub-processor' or 'service provider' (as further described in Section ‎10
      below).
    </p>

    <p>
      Accordingly, these Service Providers may have access to Volca User Data
      and Website, CRM & Prospect Data; and if we have expressly listed them in
      our Sub-Processor List, they may also have access to Customer Data, all
      depending on each of their specific roles and purposes in facilitating and
      enhancing our Services, and may only use it for such limited purposes as
      determined in our agreements with them.
    </p>

    <p>
      When our Service Providers contact you in order to offer or promote our
      Services, they may additionally interest you in their own services. Should
      you decide to engage in such activities with the Service Provider, please
      note that such engagement is beyond the scope of Volca's Terms and Privacy
      Policy and will therefore be covered by our Service Provider's Terms and
      Privacy Policy.
    </p>

    <p>
      Third Party Websites and Services: Our Sites and Platform may include
      links to third party websites, and integrations with third party services.
      Such websites and third party services, and any information you process,
      submit, transmit or otherwise use with such websites and third party
      services, are governed by such third party's terms and privacy practices
      and policies, and not by this Privacy Policy. We encourage you to
      carefully read the terms and privacy policies of such website and third
      party services.
    </p>

    <p>
      Sharing Personal Data with our Customers and other Users: Customer Data is
      typically shared and is available to the users belonging to such
      customer's account. Volca User Data is shared with the administrator of
      the customer's account to which such user belongs (including data and
      communications concerning such user's account). In such cases, sharing
      such data means that the administrator(s) or other users of the same
      account may access it on behalf of the customer, and will be able to
      monitor, process and analyze the Personal Data contained therein. This
      includes instances where you may contact us for help in resolving an issue
      specific to a team of which you are a member (and which is managed by the
      same customer).
    </p>

    <p>
      Please note that Volca is not responsible for and does not control any
      further disclosure, use or monitoring by or on behalf of the customer,
      that itself acts as the 'data controller' of such data (as further
      described in Section ‎10 below).
    </p>

    <p>
      Protecting Rights and Safety: We may share Personal Data with others if we
      believe in good faith that this will help protect the rights, property or
      personal safety of Volca, any of our users or customers, or any members of
      the general public.
    </p>

    <p>
      Volca Subsidiaries and Affiliated Companies: We may share Personal Data
      internally within our group, for the purposes described in this Privacy
      Policy. In addition, should Volca or any of its subsidiaries or affiliates
      undergo any change in control or ownership, including by means of merger,
      acquisition or purchase of substantially all or part of its assets,
      Personal Data may be shared with or transferred to the parties involved in
      such an event. If we believe that such change in control might materially
      affect your Customer Data or Personal Data then stored with us, we will
      notify you of this event and the choices you may have via e-mail or
      prominent notice on our Services.
    </p>

    <p>
      For the avoidance of doubt, Volca may share Volca User Data, Website, CRM
      & Prospect Data in additional manners, pursuant to your explicit approval,
      or if we are legally obligated to do so, or if we have successfully
      rendered such data non-personal, non-identifiable and anonymous. We may
      transfer, share or otherwise use non-personal and non-identifiable data at
      our sole discretion and without the need for further approval.
    </p>
  </section>
);
